<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
            <el-form-item label="租户名称:" prop="name">
              <el-input  placeholder="" v-model="searchFrom.name"></el-input>
            </el-form-item>
            <!-- <el-form-item label="状态:" prop="enableFlag">
                <el-select  v-model="searchFrom.enableFlag"  placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                   <el-option label="未启用" value="0"></el-option>
                  <el-option label="已启用" value="1"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="租户类型:" type="status">
                <el-select  v-model="searchFrom.type"  placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="平台型" value="0"></el-option>
                  <el-option label="租户型" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="租户来源:" prop="sourceType">
                <el-select  v-model="searchFrom.sourceType"  placeholder="请选择">
                  <el-option label="平台创建" value="1"></el-option>
                  <el-option label="租户开通" value="2"></el-option>
                  <el-option label="在线申请" value="3"></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="经营业务？:" prop="twoCustomerTaxId">
                <el-select  v-model="searchFrom.twoCustomerTaxId"  placeholder="请选择">
                  <el-option v-for="val in zuhuList" :label="val.secondaryCustomerName" :value="val.secondaryCustomerId" :key="val.secondaryCustomerId"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="统一社会信用代码:" prop="taxpayerNumber" label-width="180px">
              <el-input  placeholder="" v-model="searchFrom.taxpayerNumber"></el-input>
            </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox" style="margin-top:10px;margin-bottom:10px;">
         <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="ktwyFN()">开通网银</el-button>
          </el-form-item>
          <!-- <el-form-item >
            <el-button type="primary"  @click="addFn">添加</el-button>
          </el-form-item> -->

       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="200">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="editFN(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" btnCode="00KP002B003"   @click="detailFn(scope.row)">详情</el-button>
              <!-- 2022.06.13 crm新需求 经营业务改为关联租户 -->
              <!-- <el-button type="text" size="mini" btnCode="00KP002B003"  @click="yewuFn(scope.row)">经营业务</el-button> -->
              <el-button type="text" size="mini" btnCode="00KP002B003"  @click="relationTenant(scope.row)">关联租户</el-button>
              <el-button type="text" size="mini" btnCode="00KP002B003"  @click="CyewuFn(scope.row)">客户业务</el-button>
              <!-- 2022.06.16 测试人员改  注掉停启用按钮 -->
              <!-- <el-button type="text" size="mini" btnCode="00KP002B003"  @click="tingqiFN(scope.row)">{{scope.row.enableFlag==1?'停用':'启用'}}</el-button> -->
            </template>
        </el-table-column>
        <el-table-column prop="name"  width="260" :formatter="emptyFn" :show-overflow-tooltip="true" label="租户名称"></el-table-column>
        <el-table-column prop="aliasName"  width="260" :formatter="emptyFn" :show-overflow-tooltip="true" label="租户别名"></el-table-column>
        <el-table-column prop="code"  width="120" :formatter="emptyFn" :show-overflow-tooltip="true" label="租户编码"></el-table-column>
         <el-table-column property="type" label="租户类型" min-width="100">
          <template scope="scope">
            <div>
           {{[ "平台型", "租户型"][scope.row.type]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="sourceType" label="租户来源" min-width="100">
          <template scope="scope">
            <div>
           {{[ "平台创建", "租户开通", "在线申请"][scope.row.sourceType-1]}}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column property="enableFlag" label="状态" min-width="100">
          <template scope="scope">
            <div>
           {{[ "未启用","已启用"][scope.row.enableFlag]}}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column property="isPayAccount" label="是否开通网银" min-width="120">
          <template scope="scope">
            <div>
           {{[ "否","是"][scope.row.isPayAccount]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="isCarHold" label="客户数量" min-width="80">
          <template scope="scope">
             <el-button type="text" size="mini" btnCode="00KP002B003"   @click="kehuFn(scope.row)">{{scope.row.customerCount}}</el-button>
          </template>
        </el-table-column>
         <el-table-column property="isCarHold" label="角色数量" min-width="80">
          <template scope="scope">
             <el-button type="text" size="mini" btnCode="00KP002B003"   @click="jueseFn(scope.row)">{{scope.row.roleCount}}</el-button>
          </template>
        </el-table-column>
         <el-table-column property="isCarHold" label="用户数量" min-width="80">
          <template scope="scope">
             <el-button type="text" size="mini" btnCode="00KP002B003"   @click="yonghuFn(scope.row)">{{scope.row.userCount}}</el-button>
          </template>
        </el-table-column>
         <el-table-column prop="taxpayerNumber"  width="210" :formatter="emptyFn" label="统一社会信用代码"></el-table-column>
        <el-table-column prop="natureName"  width="160" :show-overflow-tooltip="true" :formatter="emptyFn" label="机构性质"></el-table-column>
        <el-table-column prop="legalPerson"  width="120" :formatter="emptyFn" label="法人姓名"></el-table-column>
         <!-- <el-table-column prop="contactsName"  width="120" :formatter="emptyFn" label="联系人"></el-table-column>
        <el-table-column prop="contactsMoblie"  width="120" :formatter="emptyFn" label="联系电话"></el-table-column> -->
         <el-table-column prop="createUserName" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <!-- 详情 -->
    <el-dialog  title="详情"  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"  @close="closeDialog"   :visible.sync="dialogDetail" width="1360px" center>
      <span>
        <el-form :inline="true" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="inpBox">
              <el-form-item label="租户名称:" prop="name"  label-width="129px">
                <div class="detailCont" style="width:300px">{{addFrom.name}}</div>
              </el-form-item>
              <el-form-item label="租户类型:" prop="type" label-width="278px">
                <div  style="wdith:150px">{{[ "平台型", "租户型"][addFrom.type]}}</div>
              </el-form-item>
              <el-form-item label="机构性质:" prop="nature" label-width="280px">
                <div class="detailCont" style="width:220px">{{addFrom.natureName}}</div>
              </el-form-item>
              <el-form-item label="统一社会信用代码:" prop="taxpayerNumber" label-width="185px" >
                 <div class="detailCont" style="width:220px">{{addFrom.taxpayerNumber}}</div>
              </el-form-item>
            <!-- <el-form-item label="经营业务:" prop="nature" >
                  <div class="detailCont">{{addFrom.businessName}}</div>
            </el-form-item> -->
                <el-form-item label="租户别名:" prop="aliasName" label-width="223px" >
                  <div class="detailCont" style="width:300px">{{addFrom.aliasName}}</div>
                </el-form-item>
                <el-form-item label="法人姓名:" prop="legalPerson" label-width="280px">
                   <div class="detailCont" style="width:150px">{{addFrom.legalPerson}}</div>
                </el-form-item>
                <el-form-item label="法人身份证号:" prop="legalIdentityCard" label-width="157px" >
                  <div class="detailCont" style="width:220px">{{addFrom.legalIdentityCard}}</div>
                </el-form-item>
                <el-form-item label="法人身份证是否长期:" prop="legalIsLong" class="ziti" label-width="322px" >
                   <div  style="wdith:150px">{{[ "是", "否"][addFrom.legalIsLong-1]}}</div>
                </el-form-item>
                  <el-form-item label="法人身份证有效期:" prop="legalPersonidValidity"  label-width="266px" v-if="addFrom.legalIsLong==2">
                    <el-date-picker
                      v-model="addFrom.legalPersonidValidity"
                      :disabled="true"
                      format="yyyy-MM-dd"
                      value-format="timestamp"
                      type="date"
                      placeholder="选择日期时间"
                    ></el-date-picker>
                  </el-form-item>
                  <div  style="display: flex;">
                    <el-form-item label="企业地址:" prop="detailAddress"  class="dizhi" label-width="129px" >
                      <div class="" style="width:300px">{{addFrom.detailAddress}}</div>
                    </el-form-item>
                    <el-form-item label="经度:" prop="detailAddress"   label-width="100px" style="margin-left: -99px">
                        <div  style="wdith:150px">{{addFrom.longitude}}</div>
                    </el-form-item>
                    <el-form-item label="纬度:" prop="detailAddress"   label-width="280px">
                      <div  style="wdith:150px">{{addFrom.latitude}}</div>
                    </el-form-item>
                  </div>
             <!-- <div>
               <el-form-item label="联系人:" prop="contactsName" >
                 <div  style="wdith:150px">{{addFrom.contactsName}}</div>
                </el-form-item>
               <el-form-item label="联系电话:" prop="contactsMoblie">
                 <div  style="wdith:150px">{{addFrom.contactsMoblie}}</div>
                </el-form-item>
                <el-form-item label="备注信息:" prop="remark">
                  <div class="" style="width:460px">{{addFrom.remark}}</div>
                </el-form-item>
            </div> -->
             <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>证件信息</span>
              </h4>
            </div>
            <div class="box">
              <div class="imgBox" >
                     <el-image :src="addFrom.bsnsLicensepicUrl"></el-image>
                    <h6>营业执照</h6>
                </div>
                <div class="imgBox" >
                     <el-image v-if="addFrom.legalPersonpic1Url" :src="addFrom.legalPersonpic1Url"></el-image>
                     <div v-else style="width: 340px;height: 320px;text-align: center;line-height: 320px;background: #f8f4f4;">暂无数据</div>
                    <h6>法人身份证正面</h6>
                </div>
                <div class="imgBox"  >
                     <el-image v-if="addFrom.legalPersonpic2Url" :src="addFrom.legalPersonpic2Url"></el-image>
                     <div v-else style=" width: 340px;height: 320px;text-align: center;line-height: 320px;background: #f8f4f4; ">暂无数据</div>
                    <h6>法人身份证背面</h6>
                </div>
            </div>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 经营业务 -->
    <el-dialog  title="经营业务"  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"
    @close="closeDialog"   :visible.sync="YWdialog" width="1000px" center>
      <div>
        <ul>
          <li v-for="item in YWlist" :key="item.name" style="border-bottom: 1px dashed #ddd;padding-bottom: 20px;">
            <h5>{{item.name}}</h5>
            <el-tag v-for="item1 in item.list"  :key="item1.businessName"> {{ item1.businessName }}</el-tag>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="YWdialog = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 关联租户 -->
    <el-dialog  title="关联租户"  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"
    @close="closeRelationDialog" :visible.sync="relationDialog" width="85%" center>
      <div>
        <el-table :data="relationTabList" ref="relationTabList" v-loading="relationLoading"
        style="width: 100%"   center border>
         <el-table-column label="操作"  width="60">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="enableTenant(scope.row)">{{scope.row.enable_flag==1?'停用':'启用'}}</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="name" width="220" :formatter="emptyFn" :show-overflow-tooltip="true" label="关联租户"></el-table-column>
        <el-table-column prop="business_name" width="" :formatter="emptyFn" :show-overflow-tooltip="true" label="经营业务"></el-table-column>
        <el-table-column prop="open_tenant_flag" width="" :formatter="emptyFn" :show-overflow-tooltip="true" label="开通状态"></el-table-column>
        <!-- 1 已启用 0未启用 -->
        <el-table-column prop=""  width="" :formatter="emptyFn" label="启用状态">
          <template slot-scope="scope">
            <span>{{scope.row.enable_flag==1?'已启用':'未启用'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" width="180" :formatter="dateTimeFormat"  label="开通时间"></el-table-column>
        <el-table-column prop="create_user_name" :formatter="emptyFn" label="开通人"></el-table-column>
        <el-table-column prop="disabled_time" width="180" :formatter="dateTimeFormat"  label="停用时间"></el-table-column>
        <el-table-column prop="disabled_user_name" :formatter="emptyFn" label="停用人"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- <div style="margin:10px 0;">
        <el-pagination background
          @size-change="handleSizeRelation"
          @current-change="handleCurrentRelation"
          :current-page="relationFrom.pageNo"
          :page-sizes="[50,100,200,1000]"
          :page-size="relationFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="relationFrom.total">
        </el-pagination>
      </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeRelationDialog">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 角色 -->
    <el-dialog  title="查看角色"  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"
    @close="closeDialog"   :visible.sync="JSdialog" width="1000px" center>
      <div>
        <el-table :data="JSlist"  bordersize="mini"  style="width: 100%" height="400"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="150">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="QXFN(scope.row)">权限</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="name"  width="200" :formatter="emptyFn" label="角色名称"></el-table-column>
       <el-table-column prop="tenantName" :formatter="emptyFn" label="创建租户"></el-table-column>
        <el-table-column prop="createUserName" :formatter="emptyFn" label="创建人"></el-table-column>
      </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="JSdialog = false">关闭</el-button>
      </span>
      <el-dialog  title="权限" append-to-body   :close-on-click-modal="false" :close-on-press-escape="false" class="detail"
      @close="closeDialog"   :visible.sync="QXdialog" width="500px" center>
        <div>
          <ul  class="ul">
            <li v-for="item in QXlist" :key="item.id" style="margin:20px">
              <h5 ><i class="fa fa-bars" aria-hidden="true"></i> {{item.clientClassify==1?'web端':'移动端'}}</h5>
              <div class="shuBox" >
                <el-tree
                  :data="item.sMenuTreeList"
                  :props="defaultProps"
                  ref="menuTree"
                  node-key="id"
                  :default-expand-all="true"
                  :highlight-current="true"
                  :render-content="renderContent"
                >
              </el-tree>
            </div>
            </li>
          </ul>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="QXdialog = false">关闭</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <!-- 用户 -->
    <el-dialog  title="用户查看"  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"
    @close="closeDialog"   :visible.sync="YHdialog" width="1200px" center>
      <div>
        <el-table :data="YHlist"  bordersize="mini"  style="width: 100%" height="400"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <!-- <el-table-column label="操作"  width="150">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="YHJSFN(scope.row)">角色</el-button>
            </template>
        </el-table-column> -->
        <el-table-column label="操作"  width="135" >
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="resetPassWordClick(scope.row)" >重置密码</el-button>
              <el-button type="text" size="mini" @click="sendSms(scope.row)" :disabled='scope.row.sendDisabled'>发送短信</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="userName"  width="150" :formatter="emptyFn" label="用户姓名"></el-table-column>
        <el-table-column property="isAdmin" label="是否管理员" min-width="100">
          <template scope="scope">
            <div>
           {{[ "否","是"][scope.row.isAdmin]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="userAccount"  min-width="150" :formatter="emptyFn" label="登录名"></el-table-column>
        <el-table-column prop="orgName"  width="200" :formatter="emptyFn" label="组织机构"></el-table-column>
       <el-table-column prop="createUserTenant" width="200" :formatter="emptyFn" label="创建租户"></el-table-column>
        <el-table-column prop="createUserName" width="140" :formatter="emptyFn" label="创建人"></el-table-column>
      </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="YHdialog = false">关闭</el-button>
      </span>
      <el-dialog  title="角色查看" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"
        @close="closeDialog"   :visible.sync="YHJSdialog" width="700px" center>
          <div>
                <el-checkbox-group v-model="YHJSlist">
                  <el-checkbox v-for="item in JSlist" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button  @click="YHJSdialog = false">取消</el-button>
             <el-button type="primary" @click="YHJSsaveFn('addFrom')">确 定</el-button>
          </span>
        </el-dialog>
    </el-dialog>
    <!-- 新建修改 -->
    <el-dialog  :title="title"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="1360px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="inpBox">
            <div>
               <el-form-item label="租户名称:" prop="name" >
                  <el-input  placeholder=""  maxlength="30" :class="{disabled:detailData.name}" v-if="isAdd"
                  v-model.trim="addFrom.name" @blur="nameBlur" ></el-input>
                   <el-input  placeholder="" v-else maxlength="30" class="disabled" :readonly="!isAdd"
                  v-model.trim="addFrom.name"  ></el-input>
                </el-form-item>
                <el-form-item label="租户类型:" prop="type" label-width="130px">
                <el-select  v-model="addFrom.type"  placeholder="请选择">
                  <el-option label="平台型" :value="0"></el-option>
                  <el-option label="租户型"  :value="1"></el-option>
                </el-select>
                <!-- <div v-else style="wdith:150px">{{[ "平台型", "租户型"][addFrom.type]}}</div> -->
            </el-form-item>
                <el-form-item label="机构性质:" prop="nature" label-width="130px">
                  <el-select  v-model="addFrom.nature"  placeholder="请选择">
                    <el-option v-for="val in jigouList" :label="val.showName" :value="val.itemNo"  :key="val.itemNo"></el-option>
                  </el-select>
                   <!-- <el-input   v-else  v-model="addFrom.natureName" :class="{disabled:true}"  :readonly="true"></el-input> -->
              </el-form-item>
                <el-form-item label="统一社会信用代码:" prop="taxpayerNumber" label-width="180px" >
                  <el-input  placeholder=""     maxlength="20" :class="{disabled:!isAdd?true:false}"  :readonly="!isAdd"   v-model.trim="addFrom.taxpayerNumber"></el-input>
                </el-form-item>
            </div>
            <div  v-if="isAdd">
              <business :addFrom="addFrom" openObjs='1'  v-if="dialogVisible" ></business>
            </div>
             <!-- <div  v-if="!isAdd">
               <el-form-item label="经营业务:" prop="taxpayerNumber"  >
                   <el-tag v-for="item in addFrom.businessList"  :key="item.name"> {{ item.name }}</el-tag>
                </el-form-item>

            </div> -->
            <div>
               <el-form-item label="租户别名:" prop="aliasName" >
                  <el-input  placeholder=""  maxlength="30" v-model.trim="addFrom.aliasName"  ></el-input>
                </el-form-item>
                <el-form-item label="法人姓名:" prop="legalPerson"  label-width="130px">
                  <el-input  placeholder=""     maxlength="20"   v-model.trim="addFrom.legalPerson"></el-input>
                </el-form-item>
                <el-form-item label="法人身份证号:" prop="legalIdentityCard" label-width="130px" >
                  <el-input  placeholder=""     maxlength="18"  v-model.trim="addFrom.legalIdentityCard"></el-input>
                </el-form-item>
            </div>
             <div>
               <el-form-item label="法人身份证是否长期:" prop="legalIsLong" class="ziti" label-width="152px" >
                  <template >
                    <div style="width:150px">
                       <el-radio-group v-model="addFrom.legalIsLong">
                        <el-radio :label="1" >是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item label="法人身份证有效期:" prop="legalPersonidValidity"  label-width="152px" v-if="addFrom.legalIsLong==2">
                  <el-date-picker
                    v-model="addFrom.legalPersonidValidity"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                    type="date"
                    placeholder="选择日期时间"
                  ></el-date-picker>
                </el-form-item>
            </div>
            <div style="display: flex;margin-left:11px">
              <el-form-item label="企业地址:" prop="detailAddress"  class="dizhi">
                  <el-input  placeholder=""  class="disabled"    maxlength="300" :readonly="true"  v-model="addFrom.detailAddress"></el-input>
                  <i class="el-icon-location" @click="dizhiFn"></i>
              </el-form-item>
               <el-form-item label="经度:" prop="detailAddress"   label-width="190px">
                  <el-input  placeholder=""  class="disabled"    maxlength="30" :readonly="true"  v-model="addFrom.longitude"></el-input>
              </el-form-item>
              <el-form-item label="纬度:" prop="detailAddress"   label-width="180px">
                  <el-input  placeholder=""  class="disabled"    maxlength="30" :readonly="true"  v-model="addFrom.latitude"></el-input>
              </el-form-item>
            </div>
             <div v-if="isAdd">
               <el-form-item label="联系人:" prop="contactsName" >
                  <el-input  placeholder=""     maxlength="20"   v-model.trim="addFrom.contactsName"></el-input>
                </el-form-item>
               <el-form-item label="联系电话:" prop="contactsMoblie">
                  <el-input  placeholder=""   v-number-input.float="0"    maxlength="11"   v-model.trim="addFrom.contactsMoblie"></el-input>
                </el-form-item>
                <el-form-item label="备注信息:" prop="remark">
                  <el-input  placeholder=""     maxlength="200"   v-model.trim="addFrom.remark"></el-input>
                </el-form-item>
            </div>
             <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>证件信息</span>
              </h4>
            </div>
            <div class="box" v-if="dialogVisible">
              <div class="imgBox">
                    <uploadImgs :imgList.sync='imgYY'   ></uploadImgs>
                    <h6>营业执照</h6>
                </div>
                <div class="imgBox">
                    <uploadImgs :imgList.sync='imgFRZ'   ></uploadImgs>
                    <h6>法人身份证正面</h6>
                </div>
                <div class="imgBox">
                    <uploadImgs :imgList.sync='imgFRF'    ></uploadImgs>
                    <h6>法人身份证背面</h6>
                </div>
                <!-- <div class="imgBox">
                    <uploadImgs :imgList.sync='imgQY'  ></uploadImgs>
                    <h6>企业授权书</h6>
                </div> -->
            </div>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
      <!-- 选择地址 -->
      <mapAddressT :addFrom="addFrom"  v-if="dizhiMark" @getAddress="getAddress"></mapAddressT>
      <!-- 客户业务 -->
    <el-dialog  title="经营业务"  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"
     :visible.sync="CYWdialog" width="500px" center>
      <div >
         <el-tree
                :data="CyewuList"
                :props="{
                    label: 'name',
                  }"
                show-checkbox
                ref="tree"
                node-key="id"
                :default-expand-all="true"
                :highlight-current="true"
                :expand-on-click-node="false"
                :render-content="KHYWrenderContent"
                @node-click="handleNodeClick"
            >
          </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button @click="CYWdialog = false">取 消</el-button>
        <el-button type="primary" @click="CYWsaveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
     <!--开通网银 -->
    <el-dialog  title="开通网银"  :close-on-click-modal="false" :close-on-press-escape="false"
     :visible.sync="KTWYdialog" width="700px" center>
     <div>
         <el-form :inline="true" :rules="rules" :model="KTWYfrom" ref="KTWYfrom" class="demo-form-inline jiaoyan" label-width="130px" size="mini">
             <div class="inpBox">
               <div>
                  <el-form-item label="法人姓名:" prop="legalPerson" >
                    <el-input  placeholder=""     maxlength="50"   v-model="KTWYfrom.legalPerson"></el-input>
                  </el-form-item>
               </div>
              <el-form-item label="法人身份证号:" prop="legalIdentityCard" >
                <el-input  placeholder=""     maxlength="18" v-model.trim="KTWYfrom.legalIdentityCard"></el-input>
              </el-form-item>
              <div>
                <el-form-item label="信用额度:" prop="creditMoney"  class="jiage">
                  <el-input  placeholder="" v-number-input.float="0"     maxlength="8" v-model.trim="KTWYfrom.creditMoney" ></el-input><span class="danwei">元</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="企业地址:" prop="detailAddress"   class="dizhi">
                    <el-input  placeholder=""  class="disabled"    maxlength="300" :readonly="true"  v-model="KTWYfrom.detailAddress"></el-input>
                    <i class="el-icon-location" @click="dizhiFn"></i>
                </el-form-item>
              </div>
              <el-form-item label="邮箱地址:" prop="email" >
                  <el-input  placeholder=""     maxlength="30"   v-model.trim="KTWYfrom.email"></el-input>
                </el-form-item>
             </div>
         </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button @click="KTWYdialog = false">取 消</el-button>
        <el-button type="primary" @click="KTWYsaveFn">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 重置密码 -->
    <resetPassword  :row-data="row" v-if="resetPasswordFlag" @destroy="destroy" @getList="getList"></resetPassword>
    <sendSmsDialog v-if="sendSmsVisible"  :sendSmsVisible.sync='sendSmsVisible' :userId='userId'></sendSmsDialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { addTenant, sTenantList, sCrmDictionaryList, detailTenant, updateTenant, sTenantEnableDisable, userTenantBusiness,
  findTenantUser, sCompanyDetail, roleListByTenant, roleByUserId, sUseRoleRelUpdate, sMenuTreeByRoleId, businessTree,
  sBusinessTenantCustomConfigList, sBusinessTenantCustomConfigAdd, sTenantOpenBanking, isOpenBanking, getTenantCustomRelList, disableTenant } from '@/api/newCrm'
import { emptyFn, dateTimeFormat, dateFormat, arrChaJi } from '@/utils/util'
import { compressImages } from '@/utils/compressImages'
import uploadImgs from '@/components/uploadImgs.vue'
import mapAddressT from '@/components/common/mapAddressT.vue'
import business from '@/views/newCrm/components/business.vue'
import resetPassword from '@/views/newCrm/components/resetPassword.vue'
import sendSmsDialog from '@/views/newCrm/components/sendSmsDialog.vue'
export default {
  components: {
    uploadImgs,
    mapAddressT,
    business,
    resetPassword,
    sendSmsDialog
  },
  data () {
    return {
      resetPasswordFlag: false, // 重置密码
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      title: '新建',
      dialogVisible: false,
      dialogDetail: false,
      zuhuList: [],
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' }
        ],
        nature: [
          { required: true, message: '请选择机构性质', trigger: 'blur' }
        ],
        taxpayerNumber: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        detailAddress: [
          { required: true, message: '请选择企业地址', trigger: 'blur' }
        ],
        contactsName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactsMoblie: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        legalPerson: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        legalIdentityCard: [
          { required: true, message: '请输入法人身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
          // { pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/, message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        creditMoney: [
          { required: true, message: '请输入信用额度', trigger: 'blur' }
        ]
        // legalIsLong: [
        //   { required: true, message: '请选择身份证是否长期', trigger: 'blur' }
        // ],
        // legalPersonidValidity: [
        //   { required: true, message: '请选择身份证有效期', trigger: 'blur' }
        // ]
      },
      addFrom: {
      },
      detailData: {},
      isAdd: false,
      imgYY: [],
      imgFRZ: [],
      imgFRF: [],
      imgQY: [],
      dizhiMark: false, // 地址
      jigouList: [],
      YWdialog: false, // 经营业务
      YWlist: [],
      JSdialog: false,
      JSlist: [],
      QXdialog: false,
      QXlist: [],
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      YHdialog: false,
      YHlist: [],
      YHJSdialog: false,
      YHJSlist: [],
      CYWdialog: false, // 客户业务
      CyewuList: [],
      CyewuOldList: [],
      KTWYdialog: false,
      KTWYfrom: {
        creditMoney: 100000
      },
      btnFlg: [],
      btnIdArr: ['00KP002B001', '00KP002B002', '00KP002B003'],
      relationDialog: false, // 关联租户
      relationTabList: [],
      relationFrom: {
        pageNo: 1,
        pageSize: 50,
        total: 0
      },
      tenantId: '',
      relationLoading: false,
      sendSmsVisible: false,
      userId: ''
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/basicData/shipData')
    sCrmDictionaryList({ groupNo: 'tenant_type' }).then(res => {
      this.jigouList = res
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 重置密码
    resetPassWordClick (row) {
      this.row = row
      this.resetPasswordFlag = true
    },
    // 组件销毁
    destroy () {
      this.resetPasswordFlag = false
    },
    // 树得格式化
    KHYWrenderContent (h, { node, data, store }) { // openFlag 0否，1是，
      if (data.openFlag == 1) {
        return (
          <span class="custom-tree-node">
            <span style="font-size:14px">
              {data.name }&nbsp;&nbsp;
              <el-tooltip class="item" effect="dark" content="可开通客户端" placement="top-start" >
                <i class="fa fa-desktop" aria-hidden="true"></i>
              </el-tooltip>
            </span>
          </span>)
      } else {
        return (
          <span class="custom-tree-node">
            <span style="font-size:14px">{data.name }</span>
          </span>)
      }
    },
    // 开通网银
    ktwyFN () {
      const selectData = this.$refs.table.selection
      let row = selectData[0]
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        this.KTWYfrom = {
          creditMoney: 100000
        }
        this.KTWYfrom.id = selectData[0].id
        this.$set(this.KTWYfrom, 'legalPerson', row.legalPerson)
        this.$set(this.KTWYfrom, 'legalIdentityCard', row.legalIdentityCard)
        this.$set(this.KTWYfrom, 'email', row.email)
        this.$set(this.KTWYfrom, 'detailAddress', row.provinceName + row.cityName + row.areaName + row.address)
        isOpenBanking({ id: row.id }).then(res => {
          this.KTWYdialog = true
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }
    },
    KTWYsaveFn () {
      this.$refs.KTWYfrom.validate((valid) => {
        if (valid) {
          if (this.KTWYfrom.creditMoney > 10000000) {
            this.$alert('信用金额最多只能有10000000元', '系统提示')
            return
          }
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sTenantOpenBanking(this.KTWYfrom).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.KTWYdialog = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 客户业务
    CyewuFn (row) {
      this.row = row
      businessTree().then(res => {
        sBusinessTenantCustomConfigList({ tenantCode: row.code }).then(res1 => {
          this.CyewuList = res
          this.CyewuOldList = res1
          this.$nextTick(function () {
            this.$refs.tree.setCheckedKeys(res1)
          })
          this.CYWdialog = true
        })
      })
    },
    CYWsaveFn () {
      let ids = this.$refs.tree.getCheckedKeys(true)
      if (ids.length == 0) {
        this.$alert('请选择业务类型', '系统提示')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      let addBusinessId = arrChaJi(this.CyewuOldList, ids, 2)
      let delBusinessId = arrChaJi(this.CyewuOldList, ids, 1)
      sBusinessTenantCustomConfigAdd({ tenantCode: this.row.code, addBusinessId: addBusinessId, delBusinessId: delBusinessId }).then(res => {
        loading.close()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.CYWdialog = false
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 点击字体选择取消
    handleNodeClick (data, index) {
      let checkedArr = this.$refs.tree.getCheckedNodes(false, true)
      const n = checkedArr.findIndex(d => d.id === data.id)
      if (n > -1) {
        this.$refs.tree.setChecked(data, false, true)
      } else {
        this.$refs.tree.setChecked(data, true, true)
      }
    },
    // 树得格式化
    renderContent (h, { node, data, store }) {
      if (data.aliasName) {
        return (
          <span class="custom-tree-node" >
            <span style="font-size:14px">{data.name + '（' + data.aliasName + '）'}</span>
          </span>)
      } else {
        return (
          <span class="custom-tree-node">
            <span style="font-size:14px">{data.name }</span>
          </span>)
      }
    },
    // 租户名称失去焦点
    nameBlur () {
      sCompanyDetail({ name: this.addFrom.name }).then(res => {
        if (res) {
          this.$set(this.detailData, 'name', res.name)
          this.$set(this.detailData, 'taxpayerNumber', res.taxpayerNumber)
          this.$set(this.detailData, 'nature', res.nature)
          this.$set(this.detailData, 'type', res.type)
          this.addFrom = res
          this.$set(this.addFrom, 'detailAddress', res.provinceName + res.cityName + res.areaName + res.address)
          if (this.ZtenantCode) {
            this.addFrom.tenantCode = this.ZtenantCode
          } else {
            this.addFrom.tenantCode = localStorage.getItem('tenantCode')
          }
        }
      })
    },
    // 经营业务
    yewuFn (row) {
      userTenantBusiness({ useTenantCode: row.code }).then(res => {
        this.YWlist = res
        this.YWdialog = true
      })
    },
    // 关联租户
    relationTenant (row) {
      this.relationDialog = true
      this.tenantId = row.id
      this.relationTabList = []
      this.relationFrom.total = 0
      this.getTenantCustomRelList()
    },
    getTenantCustomRelList () {
      getTenantCustomRelList({
        tenantId: this.tenantId
        // pageNo: this.relationFrom.pageNo,
        // pageSize: this.relationFrom.pageSize
      }).then(res => {
        this.relationTabList = res
        // this.relationFrom.total = res.total
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    closeRelationDialog () {
      this.relationDialog = false
    },
    // 每页条数
    handleSizeRelation (val) {
      this.relationFrom.pageSize = val
      this.getTenantCustomRelList()
    },
    // 当前页
    handleCurrentRelation (val) {
      this.relationFrom.pageNo = val
      this.getTenantCustomRelList()
    },
    // 关联租户-启用停用
    enableTenant (row) {
      let str = ''
      if (row.enable_flag == 1) { // 启用状态
        str = '停用'
      } else {
        str = '启用'
      }
      this.$confirm('是否执行' + str + '操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        disableTenant({ id: row.id, enableFlag: row.enable_flag == 1 ? 0 : 1 }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getTenantCustomRelList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 地址
    dizhiFn () {
      this.dizhiMark = true
    },
    getAddress (data) {
      this.dizhiMark = false
      console.log(this.addFrom)
      for (let key in data) {
        this.KTWYfrom[key] = data[key]
      }
    },
    // 详情
    detailFn (row) {
      detailTenant({ id: row.id }).then(res => {
        this.addFrom = { ...res }
        this.$set(this.addFrom, 'detailAddress', res.provinceName + res.cityName + res.areaName + res.address)
        this.dialogDetail = true
      })
    },
    // 停用启用
    tingqiFN (row) {
      let str = ''
      if (row.enableFlag == 1) { // 启用状态
        str = '停用'
      } else {
        str = '启用'
      }
      this.$confirm('是否执行' + str + '操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sTenantEnableDisable({ id: row.id, enableFlag: row.enableFlag == 1 ? 0 : 1 }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 属性
    outsideProp (row) {
      this.WBshuxing = true
      this.loading1 = true
      this.$nextTick(() => {
        this.$refs['outFrom'].clearValidate()
      })
      this.$set(this.outFrom, 'objClassify', 1001)
      this.outFrom.objId = row.id
      this.newFrom.objCode = row.tenantCode
      this.newFrom.objName = row.tenantName

      this.getList(this.outFrom)
    },
    // 客户数量
    kehuFn (row) {
      this.$router.push({ name: 'tenantManageCustomer', query: row })
    },
    // 角色数量
    jueseFn (row) {
      roleListByTenant({ useTenantCode: row.code }).then(res => {
        this.JSlist = res
        this.JSdialog = true
      })
    },
    QXFN (row) {
      sMenuTreeByRoleId({ roleId: row.id }).then(res => {
        this.QXlist = res
        this.QXdialog = true
      })
    },
    // 用户数量
    yonghuFn  (row) {
      findTenantUser({ useTenantCode: row.code }).then(res => {
        this.YHlist = res
        this.YHdialog = true
      })
    },
    YHJSFN (row) {
      this.row = row
      roleListByTenant({ useTenantCode: row.tenantCode }).then(res => {
        this.JSlist = res
        roleByUserId({ userId: row.id }).then(res => {
          this.YHJSlist = []
          this.oldYHJSlist = []
          res.forEach(item => {
            this.YHJSlist.push(item.id)
            this.oldYHJSlist.push(item.id)
          })
          this.YHJSdialog = true
        })
      })
    },
    YHJSsaveFn () {
      if (this.YHJSlist.length == 0) {
        this.$alert('请选择角色', '系统提示')
      } else {
        let data = {}
        data.userId = this.row.id
        data.addRoles = arrChaJi(this.YHJSlist, this.oldYHJSlist, 1)
        data.delRoles = arrChaJi(this.YHJSlist, this.oldYHJSlist, 2)
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sUseRoleRelUpdate(data).then(res => {
          loading.close()
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.dialogVisible = false
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            duration: 0,
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sTenantList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addFn () {
      this.title = '添加租户'
      this.addFrom = {

      }
      this.addFrom.businessIdList = []
      this.dialogVisible = true
      this.isAdd = true
    },

    // 修改
    editFN (row) {
      this.title = '修改'
      detailTenant({ id: row.id }).then(res => {
        this.addFrom = res
        this.$set(this.addFrom, 'detailAddress', res.provinceName + res.cityName + res.areaName + res.address)
        if (res.bsnsLicensepicUrl) {
          this.$set(this.imgYY, 0, { status: 'ready', url: res.bsnsLicensepicUrl, isEdit: true })
        }
        if (res.legalPersonpic1Url) {
          this.$set(this.imgFRZ, 0, { status: 'ready', url: res.legalPersonpic1Url, isEdit: true })
        }
        if (res.legalPersonpic2Url) {
          this.$set(this.imgFRF, 0, { status: 'ready', url: res.legalPersonpic2Url, isEdit: true })
        }
        this.dialogVisible = true
        this.addFrom.businessIdList = []
      })
      this.isAdd = false
    },
    saveFn (formName) {
      if (this.addFrom.businessIdList.length == 0 && this.isAdd) {
        this.$alert('请选择业务类型', '系统提示')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          let imgList = []
          if (this.imgYY.length == 0) {
            this.$alert('请上传营业执照', '系统提示')
            return
          }
          if (this.imgYY.length > 0 && !this.imgYY[0].isEdit) {
            imgList[0] = this.imgYY[0]
          } else if (this.imgYY.length > 0 && this.imgYY[0].isEdit) {
            imgList[0] = null
          }
          if (this.imgFRZ.length > 0 && !this.imgFRZ[0].isEdit) {
            imgList[1] = this.imgFRZ[0]
          } else if (this.imgFRZ.length > 0 && this.imgFRZ[0].isEdit) {
            imgList[1] = null
          } else {
            imgList[1] = null
          }

          if (this.imgFRF.length > 0 && !this.imgFRF[0].isEdit) {
            imgList[2] = this.imgFRF[0]
          } else if (this.imgFRF.length > 0 && this.imgFRF[0].isEdit) {
            imgList[2] = null
          } else {
            imgList[2] = null
          }

          compressImages(imgList, {
            width: 1000
          }).then(result => {
            if (result[0]) {
              imgfile.set('bsnsLicensepic', result[0])
            }
            if (result[1]) {
              imgfile.set('legalPersonpic1', result[1])
            }
            if (result[2]) {
              imgfile.set('legalPersonpic2', result[2])
            }
            this.addFrom.sourceType = 1
            imgfile.set('params', JSON.stringify(this.addFrom))
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            if (this.isAdd) {
              addTenant(imgfile).then(res => {
                loading.close()
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.dialogVisible = false
                this.getList(this.searchFrom)
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            } else {
              updateTenant(imgfile).then(res => {
                loading.close()
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.dialogVisible = false
                this.getList(this.searchFrom)
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.addFrom = {

      }
      this.imgYY = []
      this.imgFRZ = []
      this.imgFRF = []
      this.dizhiMark = false
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    },
    // 发送短信
    sendSms (row) {
      this.sendSmsVisible = true
      this.userId = row.id
      this.$set(row, 'sendDisabled', true)
      setTimeout(() => {
        this.$set(row, 'sendDisabled', false)
      }, 60000)
    }
  }
}
</script>

<style scoped lang='less'>
.ul{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  li{
    width: 45%;
  }
  h5{
    margin: 0;
    margin-bottom: 20px;
  }
  .fa{
    color:#0e6eec;
  }
}
.dizhi{
  width: 530px;
  display: flex;
  position: relative;
  .el-icon-location{
    position: absolute;
    right: -30px;
    top: 0;
    font-size: 25px;
    color: #0e6eec;
  }
  /deep/.el-input__inner{
    width: 440px!important;
  }
}
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/.el-image{
    width: 340px;
    height: 320px;
  }
}
/deep/.inpBox .el-input__inner{
  width:180px;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.detail /deep/.el-form-item__content{
  width: 150px;
}
.box{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .imgBox{
    display: flex;
    // margin-right:60px;
    flex-direction: column;
    width: 320px;
    /deep/.el-upload--picture-card{
        width: 320px;
        height: 200px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../assets/images/upload1.png);
    background-size: 320px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 320px;
    height: 200px;
  }
}
/deep/.el-tag{
  margin-right:20px;
}
/deep/.el-checkbox__inner{
      width: 18px;
    height: 18px;
    margin-right: 10px;
}
/deep/.el-checkbox__inner::after{
    height: 9px;
    left: 6px;
    top: 1px;
}
.dizhi /deep/.el-form-item__label{
flex-shrink: 0;
}
</style>
